import { createSelector } from 'reselect';
 
const selectOrganizationUnits = (state: any) => state.organizationUnits;
 
export const selectOrganizationUnitsCurrentItem = createSelector([selectOrganizationUnits], (organizationUnits) => organizationUnits.current);
 
export const selectOrganizationUnitsListItems = createSelector([selectOrganizationUnits], (organizationUnits) => organizationUnits.list);
 
 
export const selectOrganizationUnitsItemById = (itemId: any) =>
    createSelector(selectOrganizationUnitsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));
 
export const selectOrganizationUnitsQueryItems = createSelector([selectOrganizationUnits], (organizationUnits) => organizationUnits.query);

export const selectOrganizationUnitsCreatedItem = createSelector([selectOrganizationUnits], (organizationUnits) => organizationUnits.create);
 
export const selectOrganizationUnitsUpdatedItem = createSelector([selectOrganizationUnits], (organizationUnits) => organizationUnits.update);
 
export const selectOrganizationUnitsReadItem = createSelector([selectOrganizationUnits], (organizationUnits) => organizationUnits.read);
 
export const selectOrganizationUnitsDeletedItem = createSelector([selectOrganizationUnits], (organizationUnits) => organizationUnits.delete);
 
export const selectOrganizationUnitsSearchedItems = createSelector([selectOrganizationUnits], (organizationUnits) => organizationUnits.search);
 
export const selectOrganizationUnitsItemsCount = createSelector([selectOrganizationUnits], (organizationUnits) => organizationUnits.count);
 
export const selectOrganizationUnitsItemsFilter = createSelector([selectOrganizationUnits], (organizationUnits) => organizationUnits.filter);